import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useState } from 'react';
import { EyeFill } from '../../icons/EyeFill';
import { TextField } from '../TextField';
import styles from './PasswordField.module.scss';
export const PasswordField = /*#__PURE__*/ forwardRef((props, ref)=>{
    const [showPassword, setShowPassword] = useState(false);
    return /*#__PURE__*/ _jsx(TextField, _object_spread({
        collapseHelperText: false,
        ref: ref,
        type: showPassword ? 'text' : 'password',
        suffix: /*#__PURE__*/ _jsx("span", {
            className: styles.eye,
            onClick: ()=>setShowPassword(!showPassword),
            children: /*#__PURE__*/ _jsx(EyeFill, {})
        }),
        label: "Password"
    }, props));
});
